import React, { useState, useEffect } from "react";
import VideoGrid from "./VideoGrid";
import Particles from "./Particles";
import "../styles/Home.css";

const rotatingKeywords = [
  "Personalized Teaching",
  "Automated Scheduling",
  "Digital Assessments",
  "Quiz Generation",
  "Student Profiles",
];

const Home = ({ darkMode }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % rotatingKeywords.length);
    }, 4500); // Change every 2.5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`home ${darkMode ? "dark" : "light"}`}>
      <Particles darkMode={darkMode} />

      {/* Left-side text container */}
      <div className="home-text">
        <h1>
          Transform your teaching
          <br />
        </h1>
        <p>
          10X your coachings growth with our advanced AI powered tools.
        </p>
        <h1>
        <span className="dynamic-text">{rotatingKeywords[currentIndex]}</span>
        </h1>
      </div>

      <div className="video-grid-container">
        <VideoGrid darkMode={darkMode} />
      </div>
    </div>
  );
};

export default Home;
